








































import { Component, Vue } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { ILoginRequest } from '../../shared/models';
import { requiredOnChange } from '@/shared/validation/rule';
@Component({
  components: {},
})
export default class Home extends Vue {
  loginForm: ILoginRequest = {
    email: '',
    password: '',
  };

  protected rules = {
    email: [requiredOnChange],
    password: [requiredOnChange],
  }

  private submitForm() {
    const vm = this;
    (this.$refs.loginForm as Form).validate(async (valid) => {
      if (valid) {
        const loginSuccess = await vm.$store.dispatch('login', this.loginForm);
        if (loginSuccess) {
          console.info('SUCCESS LOGIN');
          vm.$router.push({
            name: 'stats',
          });
        } else {
          vm.$notify.error('Sai thông tin đăng nhập');
        }
      }
    });
  }

  private resetForm(formName: string) {
    (this.$refs[formName] as Form).resetFields();
  }
}
